import React from "react";
import { withI18n } from "react-i18next";
import styled from "styled-components";

// @ts-ignore
import { moment } from "cwb-react";
import { IActorConflict } from "../../../interfaces/IActorConflicts";
import { IAuditionInfoSheetDto } from "../../../interfaces/IAuditionInfoSheetDto";
import { ISessionTemplateInfoSheet } from "../../../interfaces/ISessionTemplateInfoSheet";

const ConflictsSection = (props: {
  t: any;
  sessionTemplateInfoSheet: ISessionTemplateInfoSheet;
  isReadOnly: boolean;
  setDefault?: boolean;
  conflicts?: string;
  auditionInfoSheet?: IAuditionInfoSheetDto;
  infoSheetConflicts?: IActorConflict[];
  isTvFilm: boolean;
  handleChange?: (e: any) => void;
}) => {
  const {
    t,
    sessionTemplateInfoSheet,
    isReadOnly,
    conflicts,
    auditionInfoSheet,
    infoSheetConflicts,
    isTvFilm,
    handleChange,
  } = props;
  return (
    <section>
      {sessionTemplateInfoSheet &&
        sessionTemplateInfoSheet.shootStartDate &&
        sessionTemplateInfoSheet.shootEndDate && (
          <>
            <Title>Shoot Date Conflicts: *</Title>
            <form>
              <div className="form-group row">
                <label className="col-12 col-form-label">
                  {`${moment
                    .moment(sessionTemplateInfoSheet.shootStartDate)
                    .format("LL")} to ${moment
                    .moment(sessionTemplateInfoSheet.shootEndDate)
                    .format("LL")}`}
                </label>
              </div>
              <div className="form-group row">
                <div className="col-12">
                  <RadioWrapper>
                    <RadioInput
                      type="radio"
                      id="1-a"
                      name={"hasConflict"}
                      disabled={true}
                      onChange={handleChange}
                      checked={
                        auditionInfoSheet && auditionInfoSheet.hasConflict === 1
                      }
                      value={1}
                    />
                    <RadioStyledInput />
                    <RadioLabelTitle htmlFor="1-a">
                      {t("Available")}
                    </RadioLabelTitle>
                    {/* </RadioWrapper>
            <RadioWrapper> */}
                    <RadioInput
                      type="radio"
                      id="2-a"
                      name={"hasConflict"}
                      disabled={true}
                      onChange={handleChange}
                      checked={
                        auditionInfoSheet && auditionInfoSheet.hasConflict === 3
                      }
                      value={3}
                    />
                    <RadioStyledInput />
                    <RadioLabelTitle htmlFor="2-a">
                      {t("Not Available")}
                    </RadioLabelTitle>
                    {/* </RadioWrapper>
            <RadioWrapper> */}
                    <RadioInput
                      type="radio"
                      id="3-a"
                      name={"hasConflict"}
                      disabled={true}
                      onChange={handleChange}
                      checked={
                        auditionInfoSheet && auditionInfoSheet.hasConflict === 2
                      }
                      value={2}
                    />
                    <RadioStyledInput />
                    <RadioLabelTitle htmlFor="3-a">
                      {t("Partially Available")}
                    </RadioLabelTitle>
                  </RadioWrapper>
                </div>
              </div>
              <div className="form-group row">
                {auditionInfoSheet &&
                  (auditionInfoSheet.hasConflict === 2 ||
                    auditionInfoSheet.hasConflict === 3) && (
                    <>
                    <label
                      className="col-12 col-form-label"
                      style={{ fontSize: "12px" }}
                    >
                      <i
                        className="icon-cwb-warning"
                        style={{
                          marginRight: "16px",
                        }}
                      ></i>
                      {t(
                        "Please enter details at the input box below and see casting."
                      )}
                    </label>
                    <textarea
                      rows={4}
                      className="form-control"
                      value={
                        (auditionInfoSheet && auditionInfoSheet.availNotes) ||
                        ""
                      }
                      readOnly={true}
                      name="availNotes"
                      style={{
                        resize: "none",
                        marginTop: "6px",
                        marginLeft: "17px",
                      }}
                    />
                    </>
                  )}
              </div>
            </form>
            {!isTvFilm ? (
              <>
                <Title>Product conflicts: </Title>
                <form>
                  <div className="form-group row">
                    <label className="col-12 col-form-label">
                      {conflicts ? (
                        <span>{conflicts}</span>
                      ) : (
                        <span>{t("No conflicts listed by casting")}</span>
                      )}
                    </label>
                  </div>
                </form>
                <Title>Do you have any product conflicts? *</Title>
                <form>
                  <div className="form-group row">
                    <div className="col-12">
                      <RadioWrapper>
                        <RadioInput
                          type="radio"
                          id="1-c"
                          name={"conflict"}
                          disabled={isReadOnly}
                          defaultChecked={
                            infoSheetConflicts && infoSheetConflicts.length > 0
                          }
                        />
                        <RadioStyledInput />
                        <RadioLabelTitle htmlFor="1-c">
                          {t("Yes")}
                        </RadioLabelTitle>
                        <RadioInput
                          type="radio"
                          id="2-c"
                          name={"conflict"}
                          disabled={isReadOnly}
                          defaultChecked={
                            !infoSheetConflicts ||
                            infoSheetConflicts.length === 0
                          }
                        />
                        <RadioStyledInput />
                        <RadioLabelTitle htmlFor="2-c">
                          {t("No")}
                        </RadioLabelTitle>
                      </RadioWrapper>
                      {infoSheetConflicts && infoSheetConflicts.length > 0 && (
                        <table style={{ border: "none" }}>
                          {infoSheetConflicts.map((x, idx) => (
                            <tr key={idx}>
                              <td style={{ paddingRight: "50px" }}>
                                {x.conflictProduct}
                              </td>
                              <td>{x.conflictExpiry}</td>
                            </tr>
                          ))}
                        </table>
                      )}
                    </div>
                  </div>
                </form>
              </>
            ) : null}
          </>
        )}
    </section>
  );
};

export default withI18n()(ConflictsSection);

const Title = styled.div`
  color: ${(p) => p.theme.formField.color};
  font-size: ${(p) => p.theme["lg-font-size"]};
  font-weight: ${(p) => p.theme["font-weight-600"]};
  line-height: 22px;
  margin-top: 20px;
`;

const RadioWrapper = styled.div`
  display: inline-block;
  position: relative;
  line-height: ${(props) => props.theme.formField["font-size"]};

  .fake-radio-button {
    fill: white;
  }

  input:disabled:checked + div svg .styled-radio-button-center {
    fill: ${(props) => props.theme.formField.disabled["color"]};
  }

  .styled-radio-button-outline {
    stroke: ${(props) => props.theme.formField.outline};
  }

  input:not(:disabled):hover + div svg .styled-radio-button-outline,
  input:not(:disabled):checked + div svg .styled-radio-button-outline {
    stroke: ${(props) => props.theme.lightBlue};
  }

  input:checked + div svg .styled-radio-button-center {
    fill: ${(props) => props.theme.lightBlue};
  }

  input:focus + div svg {
    box-shadow: 0 0 6px rgba(25, 99, 246, 0.6);
    border-radius: 100%;
  }

  input:disabled + div,
  input:disabled,
  input:disabled ~ label {
    cursor: not-allowed;
  }

  input:disabled + div svg .styled-radio-button-outline {
    stroke: ${(props) => props.theme.formField.disabled["color"]};
  }

  border-radius: 4px;
  padding: 2px 0px;
  width: 100%;
`;

const RadioInput = styled.input`
  cursor: pointer;
  opacity: 0;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 15px;
  height: 15px;
  z-index: 100;
  padding: 0px;
  margin: 0px;
  vertical-align: middle;
`;

const RadioLabelTitle = styled.label`
  color: ${(p) => p.theme.formField["color"]};
  font-family: ${(props) => props.theme["font-family"]};
  font-size: ${(props) => props.theme.formField["font-size"]};
  margin-left: 18px;
  margin-top: 11px;
  vertical-align: middle;

  &:hover {
    cursor: pointer;
  }
`;

const RadioStyledInput = () => (
  <StyledInputWrapper
    dangerouslySetInnerHTML={{
      __html: `<svg width="15" height="15" viewBox="0 0 15 15" style="overflow: visible">
    <g stroke="none" strokeWidth="1" fill="none" fill-rule="evenodd">
      <g transform="translate(-69.000000, -293.000000)">
        <g transform="translate(69.000000, 268.000000)">
          <g transform="translate(0.000000, 25.000000)">
            <circle fill="#FFFFFF" cx="7.5" cy="7.5" r="7.5"></circle>
            <path class="styled-radio-button-outline" d="M7.5,15 C11.6421356,15 15,11.6421356 15,
              7.5 C15,3.35786438 11.6421356,0 7.5,0 C3.35786438,0 0,3.35786438 0,7.5 C0,
              11.6421356 3.35786438,15 7.5,15 Z M7.5,14 C11.0898509,14 14,11.0898509 14,
              7.5 C14,3.91014913 11.0898509,1 7.5,1 C3.91014913,1 1,3.91014913 1,7.5 C1,
              11.0898509 3.91014913,14 7.5,14 Z" fill="#AFAFAF"></path>
            <circle fill="white" cx="7.5" cy="7.5" r="3.5" class="styled-radio-button-center"></circle>
          </g>
        </g>
      </g>
    </g>
  </svg>`,
    }}
  />
);

const StyledInputWrapper = styled.div`
  z-index: 1;
  display: inline;
  margin-left: 10px;
`;
